













































































import { Vue, Component, Prop } from 'vue-property-decorator'

import ContentStoreModule from '../store/ContentStoreModule'
import CoreStoreModule from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'

import { PageLayout, ContainerLayout, LinearLayout, ClickEvent, BaseTabs, BaseCard, ChangeEvent, BaseButton, BaseIcon, BaseHeading, BaseTable, BaseText, BaseDateText } from '@revas/reef'

import AppError from '@revas/kadra-library/src/core/app/vue/vuex/AppError'

import { Content, Directory } from '@/models'
import ListContentsActionPayload from '../store/models/content/ListContentsActionPayload'
import Page from '../store/models/pagination/Page'

@Component({
  components: {
    PageLayout,
    ContainerLayout,
    LinearLayout,
    BaseButton,
    BaseIcon,
    BaseHeading,
    BaseTable,
    BaseText,
    BaseTabs,
    BaseCard,
    BaseDateText
  }
})
export default class VContentCollection extends Vue {
  @Prop() readonly contentStoreModule!: ContentStoreModule
  @Prop() readonly coreStoreModule!: CoreStoreModule
  @Prop() readonly appStoreModule!: AppStoreModule
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly router!: VueRouter
  @Prop() readonly routeName!: string
  @Prop() readonly directoryId!: string

  async created () {
    await this.contentStoreModule.asyncGetDirectory({ directoryId: this.directoryId })
    const page: Page<Content> = new Page()
    if (this.currentPage === 0) {
      page.number = 1
    } else {
      page.number = this.currentPage
    }
    this.listContents(page)
  }

  get directory (): Directory | null {
    return this.contentStoreModule.currentDirectory
  }

  get contents (): Content[] {
    const c = this.contentStoreModule.currentContentsItems
    if (c === null) {
      return []
    } else {
      return c
    }
  }

  get organization () {
    return this.coreStoreModule.activeUserOrganization
  }

  //
  //
  // Pagination

  get currentPage (): number {
    return this.contentStoreModule.currentContentsPage
  }

  get hasNextPage (): boolean {
    return this.contentStoreModule.currentContentsHasNextPage
  }

  onChangePage (pageNumber: number) {
    const page: Page<Content> = new Page<Content>()
    page.number = pageNumber
    this.listContents(page)
  }

  async listContents (page: Page<Content>) {
    const listContentsPayload = new ListContentsActionPayload(page, this.directoryId)
    await this.contentStoreModule.asyncListContents(listContentsPayload)
  }

  //
  //
  // Table options

  tableTemplate = [
    {
      key: 'name',
      label: this.i18n.t('contents.content_name')
    },
    {
      key: 'title',
      label: this.i18n.t('contents.content_title')
    },
    {
      key: 'publishTime',
      label: this.i18n.t('contents.published_on')
    }
  ]

  onContentClick ($event: ClickEvent<Content>) {
    if ($event.value === null) {
      const errorPayload = new AppError()
      this.appStoreModule.asyncPushError(errorPayload)
      return
    }
    this.goToContent($event.value.id)
  }

  goToContent (contentId: string) {
    this.router.push({
      name: 'content',
      params: {
        directoryId: this.directoryId,
        contentId: contentId
      }
    })
  }

  //
  //
  // Navbar options
  goToCreateContent () {
    this.router.push({
      name: 'content',
      params: {
        directoryId: this.directoryId,
        contentId: '-'
      }
    })
  }

  //
  //
  // Top navigation
  private tabItems = [
    {
      key: 'directories',
      value: this.i18n.t('contents.directories')
    }
  ]

  onTabChange ($event: ChangeEvent<string>) {
    if ($event.value !== null && $event.value !== this.routeName) {
      this.router.push({
        name: $event.value
      })
    }
  }

  //
  //
  // Directory navigation
  private internalTabItems = [
    {
      key: 'contents',
      value: this.i18n.t('contents.contents')
    },
    {
      key: 'settings',
      value: this.i18n.t('contents.settings')
    }
  ]

  onInternalTabChange ($event: ChangeEvent<string>) {
    if ($event.value !== null && $event.value !== this.routeName) {
      this.router.push({
        name: $event.value,
        params: {
          directoryId: this.directoryId
        }
      })
    }
  }
}
